import { render, staticRenderFns } from "./CDR.vue?vue&type=template&id=92a99dfa&scoped=true&"
import script from "./CDR.vue?vue&type=script&lang=js&"
export * from "./CDR.vue?vue&type=script&lang=js&"
import style0 from "./CDR.vue?vue&type=style&index=0&id=92a99dfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a99dfa",
  null
  
)

export default component.exports